import React from "react";
import ReactDOM from "react-dom";
import {Route, Switch, withRouter} from "react-router";
import {BrowserRouter} from "react-router-dom";
import routes from "./routes";
import IndexPage from "./pages/IndexPage";
import CreatePage from "./pages/create/CreatePage";
import UploadPage from "./pages/UploadPage";
import ErrorPage from "./pages/ErrorPage";
import QRCodeCameraPage from "./pages/QRCodeCameraPage";
import ProcessingPage from "./pages/ProcessingPage";
import ResultPage from "./pages/result/ResultPage";
import "./styles/app.scss";
import ModalWrapper from "./components/ModalWrapper";
import {AppContextProvider} from "./contexts/AppContext";
import AppContext from "./contexts/AppContext";
import {hitEvent, hits} from "./utils/log";
import * as webviewUtils from "./utils/webview";

class App extends React.Component {

  componentDidMount() {
    document.body.classList.add("app-locale--" + window.clientConfig.locale);
    document.body.classList.add("app-locale--" + window.clientConfig.lang);
    document.body.classList.add("app-type--" + (window.clientConfig.isWebview ? "webview" : "web"));

    if (window.clientConfig.isWebviewIOS) {
      document.body.classList.add("app-webview--ios");
    }

    if (window.clientConfig.isWebviewAndroid) {
      document.body.classList.add("app-webview--android");
    }

    window.webviewHolders.tabSelected.subscribe((v) => {
      if (v > 0) {
        hitEvent(hits.TAB_OPENED);
      }
    });

    if (window.clientConfig.isWebview) {
      webviewUtils.webviewCheckInstalledApps((apps) => {
        this.context.setInstalledApps(apps);
      })
    }
  }

  render() {
    return <React.Fragment>
      <Switch>
        <Route exact path={routes.INDEX} render={props => <IndexPage {...props} />} />
        <Route exact path={routes.CREATE} render={props => <CreatePage {...props} />} />
        <Route exact path={routes.UPLOAD} render={props => <UploadPage {...props} />} />
        <Route exact path={routes.ERROR} render={props => <ErrorPage {...props} />} />
        <Route exact path={routes.QRCODE_CAMERA} render={props => <QRCodeCameraPage {...props} />} />
        <Route exact path={routes.PROCESSING} render={props => <ProcessingPage {...props} />} />
        <Route exact path={routes.RESULT} render={props => <ResultPage {...props} />} />
      </Switch>
      <ModalWrapper />
    </React.Fragment>;
  }
}

App.contextType = AppContext;

const AppWithRouter = withRouter(App);

ReactDOM.render(
  <BrowserRouter>
    <AppContextProvider>
      <AppWithRouter />
    </AppContextProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
